function distanciaMetros(a, b) {
  const R = 6371000;
  const toRad = (v) => (v * Math.PI) / 180;

  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);

  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) *
      Math.cos(toRad(b.lat)) *
      Math.sin(dLng / 2) ** 2;

  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

export function formatearInfoPlayback(ruta, index) {
  const punto = ruta?.[index];

  return {
    hora: punto?.fecha
      ? new Date(punto.fecha).toLocaleTimeString('es-CO')
      : '--:--:--',
    progreso: ruta?.length
      ? Math.round(((index + 1) / ruta.length) * 100)
      : 0,
    velocidad: Math.round(Number(punto?.speed || 0))
  };
}

function interpolar(origen, destino, progreso) {
  return {
    ...destino,
    lat: origen.lat + (destino.lat - origen.lat) * progreso,
    lng: origen.lng + (destino.lng - origen.lng) * progreso,
    speed: origen.speed + (destino.speed - origen.speed) * progreso
  };
}

function obtenerVelocidadPlayback(velocidad) {
  if (velocidad === 'lento') return 75;
  if (velocidad === 'rapido') return 320;
  return 140;
}

export function crearPlaybackEngine({
  ruta,
  velocidad = 'medio',
  desdeIndex = 0,
  onFrame,
  onFinish
}) {
  if (!Array.isArray(ruta) || ruta.length < 2) {
    onFinish?.();
    return { detener() {} };
  }

  let rafId = null;
  let detenido = false;
  let ultimoTiempo = null;

  const distancias = [0];

  for (let i = 1; i < ruta.length; i++) {
    distancias[i] =
      distancias[i - 1] + distanciaMetros(ruta[i - 1], ruta[i]);
  }

  const distanciaTotal = distancias[distancias.length - 1];

  let distanciaActual = distancias[Math.max(0, desdeIndex)] || 0;
  const metrosPorSegundo = obtenerVelocidadPlayback(velocidad);

  const buscarSegmento = (distancia) => {
    for (let i = 0; i < distancias.length - 1; i++) {
      if (distancia >= distancias[i] && distancia <= distancias[i + 1]) {
        return i;
      }
    }

    return ruta.length - 2;
  };

  const frame = (timestamp) => {
    if (detenido) return;

    if (!ultimoTiempo) ultimoTiempo = timestamp;

    const deltaSeg = (timestamp - ultimoTiempo) / 1000;
    ultimoTiempo = timestamp;

    distanciaActual += metrosPorSegundo * deltaSeg;

    if (distanciaActual >= distanciaTotal) {
onFrame?.({
  index: ruta.length - 1,
  position: ruta[ruta.length - 1],
  travelledPath: ruta,
  progress: 100,
  finalizado: true
});

      onFinish?.();
      return;
    }

    const index = buscarSegmento(distanciaActual);

    const distanciaInicio = distancias[index];
    const distanciaFin = distancias[index + 1];
    const tramo = distanciaFin - distanciaInicio || 1;

    const progresoSegmento =
      (distanciaActual - distanciaInicio) / tramo;

    const position = interpolar(
      ruta[index],
      ruta[index + 1],
      progresoSegmento
    );

onFrame?.({
  index,
  position,
  travelledPath: [
    ...ruta.slice(0, index + 1),
    position
  ],
  progress: Math.round((distanciaActual / distanciaTotal) * 100),
  finalizado: false
});

    rafId = requestAnimationFrame(frame);
  };

  rafId = requestAnimationFrame(frame);

  return {
    detener() {
      detenido = true;
      if (rafId) cancelAnimationFrame(rafId);
    }
  };
}